import Rest from './BaseRest'
import DjangoRest from './DjanoBaseRest.js'

const resource = 'company'
const postfix = 'invoices'

export default {
  FetchCompanyInvoices () {
    return Rest.get(`${resource}/${postfix}`)
  },
  DestroyInvoice (id) {
    return Rest.delete(`${resource}/${id}`)
  },
  recentInvoices (companyId) {
    return DjangoRest.get(`${resource}/${postfix}/${companyId}/recent`)
  },
  failedInvoices (companyId) {
    //return Rest.get(`${resource}/${postfix}/${companyId}/failed`)
    return DjangoRest.get(`/get_failed_payments/`)
  }
}
